module.exports = __webpack_public_path__ + "static/img/join_5.ff3d26c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/join_5.jpg
// module id = PtzB
// module chunks = 0